<template>
  <div>
    <div class="header">

      <div class="logo-container">
        <img src="@/assets/img/logo.png" alt="Logo" class="logo-img"/>
        <div class="logo-text">高效办成一件事</div>
      </div>

      <div class="header-right">
        <div class="user-info">
          <span class="user-name">{{displayUserName}}</span>
        </div>
        <p @click="logOut">退出登录</p>
      </div>
    </div>
  </div>
</template>

<script>
import {getCustomByTicket} from "@/api/zwfwLogin";
import {Base64} from 'js-base64';

export default {
  components: {
  },
  data() {
    return {
      ticket: '',
      gotoUrl: '',
      userName:'',
    };
  },
  computed: {
    displayUserName() {
      if (!this.userName) return '';

      const nameLength = this.userName.length;

      // 如果用户名长度为1，直接显示
      if (nameLength === 1) {
        return this.userName;
      }

      // 如果用户名长度大于1，前面用星号代替，只显示最后一个字
      const stars = '*'.repeat(nameLength - 1);
      return stars + this.userName.slice(-1);
    }
  },
  watch: {},
  methods: {
    logOut() {
      window.sessionStorage.clear()
      window.localStorage.clear()
      // 跳转到登录页
      /*var a = Base64.encode('https://www.jszwfw.gov.cn/jsjis/front/login.do?uuid=Qc2DWxfKJaLI&gbtrust=1');
      window.location.href = 'https://www.jszwfw.gov.cn/jszwfw/member/otherLogin/logout.do?gotourl=' + a;
      // this.$router.replace('https://www.jszwfw.gov.cn/jsjis/front/login.do?uuid=Qc2DWxfKJaLI');*/
      if(this.gotoUrl) {
        window.location.href = 'https://www.jszwfw.gov.cn/jsjis/front/login.do?uuid=Qc2DWxfKJaLI&gotoUrl=' + this.gotoUrl;
      }else{
        window.location.href = 'https://www.jszwfw.gov.cn/jsjis/front/login.do?uuid=Qc2DWxfKJaLI';
      }
    },
  },

  async created() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      this.gotoUrl = urlParams.get('gotoUrl')
      const routeQuery = this.$route.query;
      this.ticket = routeQuery.ticket || urlParams.get('ticket');

      if (this.ticket && this.ticket.trim() !== '') {
        sessionStorage.setItem("ticket", this.ticket);
        const param = {ticket: this.ticket};
        await Promise.all([
          getCustomByTicket(param).then((res) => {
            console.log("[getCustomByTicket] 返回数据：", res);
            if (res && res.data) {
              this.userName = res.data.name;
              sessionStorage.setItem("customData",JSON.stringify(res.data));
            }
          }),
        ]);
        console.log("用户信息和票据验证完成");
      } else {
        console.warn("未获取到有效的 ticket");
      }

      //处理跳转逻辑
      if (this.gotoUrl) {
        console.log('准备跳转到业务地址:', this.gotoUrl);
        window.location.href = this.gotoUrl;
      }
    } catch (err) {
      console.error("初始化过程发生错误：", err);
      if (this.gotoUrl) {
        console.log('发生错误，但仍跳转到业务地址:', this.gotoUrl);
        window.location.href = this.gotoUrl;
      }
    }
  },
  mounted() {

  },
};
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 100px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-img {
  height: 60px;
  width: auto;
  margin-right: 22px;
}

.logo-text {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px; /* 设置元素之间的间距 */
}

.user-info {
  display: flex;
  align-items: center;
}

.user-name {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.header-right p {
  cursor: pointer;
  color: #666;
  font-size: 14px;
  margin: 0; /* 移除默认边距 */
}

.header-right p:hover {
  color: #007bff;
}
</style>
